import { Form, Modal, Input, Button, Select, Space, InputNumber, Row, Col, Checkbox, Divider } from "antd";
import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { useForm } from "antd/es/form/Form";
import { createUser, readItems, readRoles, readUsers } from "@directus/sdk";
import { useSelector } from "react-redux";
import moment from "moment";
import { message } from "antd";
const { Option } = Select;

function Createseller(props) {
  const [roles, setRoles] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [prestamo, setPrestamo] = useState(false);
  const [showCreditFields, setShowCreditFields] = useState(false);
  const [tipoCliente, setTipoCliente] = useState('natural');
  const [users, setUsers] = useState([]);
  const [selectedBodega, setSelectedBodega] = useState(null);
  const userdata = useSelector(state=>state.userdata)
  const dataRemoto = useSelector(state=>state?.dataRemoto?.dataRemoto)
  const [form] = useForm();

  const Roles = async () => {
    const directus = await getDirectusClient();

    directus
      .request(
        readRoles({
          filter: {
            name: {
            _eq: "clientes"
          }
        }
      }))
      .then((res) => {
       
        setRoles(res);
      })
      .catch((err) => console.error(err));
  };

  const Bodegas = async () => {
    const directus = await getDirectusClient();
   

    directus
      .request(
        readItems("bodegas", {
          filter: {
            ...(userdata.role.name === "coordinador_ruta" || userdata.role.name=="supervisor_ruta" ? { id: { _eq: userdata.bodega.id } } : {}),
        }
      }))
      .then((res) => {
       
        setBodegas(res);
      })
      .catch((err) => console.error(err));
  };

  const getUsers = async (bodegaId) => {
    const directus = await getDirectusClient();

    directus
      .request(
        readUsers({
          fields: [
            "id",
            "first_name",
            "last_name",
            "email",
            "documento",
            "role.name",
            "bodega.id",
            "direccion",
          ],
          limit:-1,
          filter: {
            _and: [
              {
                role: {
                  name: {
                    _eq: "Aliados",
                  },
                },
              },
              {
                bodega: {
                  id: {
                    _eq: bodegaId,
                  },
                },
              },
            ],
          },
        })
      )
      .then((res) => {
        setUsers(res);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
      });
  };

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    directus
      .request(
     createUser(values))
      .then((res) => {
       
        if (res.id) {
          props.closeCreate();
          form.resetFields();
          props.getSellers();
        }
      })
      .catch((err) => {
        console.error(err);
        console.error(err);
        if (err.errors && err.errors.length > 0) {
          const errorMessage = err.errors[0].message;
          if (errorMessage.includes("invalid input syntax for type integer")) {
            message.error("Error al actualizar cliente: Algunos campos numéricos contienen valores no válidos. Por favor, verifique que los números sean enteros.");
          } else if (errorMessage.includes("has to be unique") && errorMessage.includes("email")) {
            message.error("Error al actualizar cliente: El correo electrónico ya está en uso. Por favor, ingrese un correo diferente.");
          } else {
            message.error("Error al actualizar cliente. Por favor, verifique los datos ingresados.");
          }
        } else {
          message.error("Error al actualizar cliente. Por favor, verifique los datos ingresados.");
        }
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  const handleCreditChange = (checked) => {
    setShowCreditFields(checked);
    form.setFieldsValue({
      credito: checked,
      // Clear credit related fields if unchecking
      ...((!checked) && {
        dias_max_credito: undefined,
        tope_credito: undefined
      })
    });
  };

  useEffect(() => {
    form.setFieldValue("email", new Date().getTime() + "client@emesmart.com");  
    form.setFieldValue("password", new Date().getTime() + "client");
    form.setFieldValue("latitude", 0)
    form.setFieldValue("longitude", 0)
    Roles();
    Bodegas();
  }, []);
  return (
    <Modal
      open={props.opencreate}
      onCancel={props.closeCreate}
      title="Crear Cliente"
      footer={[
        <Button key="back" onClick={props.closeCreate}>
          cancelar
        </Button>,
      ]}
           width={1000}
    >
      <div style={{ margin: 20 }}>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          layout="vertical"
          style={{ maxWidth: '100%' }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Divider orientation="left">Datos personales</Divider>
          <Row gutter={16}>
            <Col span={12}>
            <Form.Item
                label="Tipo persona"
                name="tipo_cliente"
               
              >
                <Select onChange={(value) => setTipoCliente(value)}>
                  <Option value="natural">Natural</Option>
                  <Option value="juridica">Jurídica</Option>
                </Select>
              </Form.Item>
           
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
            <Form.Item
                label="Nombre"
                name="first_name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            {tipoCliente === 'natural' && (
              <Col span={12}>
                <Form.Item
                  label="Apellidos"
                  name="last_name"
                >
                  <Input />
                </Form.Item>
              </Col>
            )}
            <Col span={12}>
              <Form.Item
                label="Documento"
                name="documento"
               
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Correo"
                name="email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="role"
                label="Rol"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Seleccione un rol"
                  allowClear
                  onChange={(select) => {
                    if (select == "7fccd349-4875-4618-b770-344c5cc2e0d8") {
                      setPrestamo(true);
                    } else {
                      setPrestamo(false);
                    }
                  }}
                >
                  {roles?.map((rol) => (
                    <Option key={rol.id} value={rol.id}>
                      {rol.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="bodega"
                label="Bodega"
                rules={[{ required: true, message: 'Por favor seleccione una bodega' }]}
              >
                <Select
                  placeholder="Seleccione una bodega"
                  allowClear
                  onChange={(value) => {
                    setSelectedBodega(value);
                    if (value) {
                      getUsers(value);
                    } else {
                      setUsers([]);
                    }
                    // Clear superior selection when bodega changes
                    form.setFieldValue("superior", undefined);
                  }}
                >
                  {bodegas?.map((bodega) => (
                    <Option key={bodega.id} value={bodega.id}>
                      {bodega.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
           
            <Col span={12}>
              <Form.Item
                name="superior"
                label="Aliado"
                rules={[{ required: false }]}
              >
                <Select
                  placeholder="Seleccione un Aliado"
                  allowClear
                  disabled={!selectedBodega}
                  showSearch
                  filterOption={false}
                  onSearch={(value) => {
                    if (value) {
                      const filteredUsers = users.filter(user => 
                        `${user.first_name} ${user.last_name}`.toLowerCase().includes(value.toLowerCase())  
                      );
                      setUsers(filteredUsers);
                    } else {
                      getUsers(selectedBodega);
                    }
                  }}
                  style={{ width: "100%" }}
                >
                  {users?.map((user) => (
                    <Option key={user.id} value={user.id}>
                      {user.first_name} {user.last_name}
                      <span style={{ fontSize: "12px", color: "green" }}>
                        {user.role.name}
                      </span>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="ID Remoto"
                name="idremoto"
                rules={[{ required: dataRemoto, message: 'Por favor ingrese el ID Remoto' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Datos del establecimiento</Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Total personas"
                name="total_personas"
             
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Encargado"
                name="encargado"
              
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Codigo del establecimiento"
                name="codigo_establecimiento"
          
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Representante legal"
                name="representante_legal"
             
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Direccion"
                name="direccion"
          
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Datos de contacto</Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Celular"
                name="celular"
                rules={[
                
                  { max: 8, message: 'El celular debe tener máximo 8 dígitos' },
                  { pattern: /^[0-9]*$/, message: 'Solo se permiten números' }
                ]}
              >
                <Input maxLength={8} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Telefono"
                name="telefono"
                rules={[
                
                  { pattern: /^[0-9]*$/, message: 'Solo se permiten números' }
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Latitude"
                name="latitude"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Longitude"
                name="longitude"
                rules={[{ required: false }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">Datos de crédito</Divider>
          {prestamo && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Tope de prestamo"
                  name="tope_de_prestamo"
                  rules={[{ required: false }]}
                >
                  <InputNumber style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="¿Credito?"
                name="credito"
                valuePropName="checked"
                initialValue={false}
              >
                <Checkbox onChange={(e) => handleCreditChange(e.target.checked)} />
              </Form.Item>
            </Col>
          </Row>
          {showCreditFields && (
            <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Tope de credito"
                name="tope_credito"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el tope de crédito",
                  },
                  {
                    type: 'number',
                    min: 0,
                    message: "El tope de crédito debe ser un número positivo",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Dias de credito"
                name="dias_max_credito"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese los días de crédito",
                  },
                  {
                    type: 'number',
                    min: 1,
                    message: "Los días de crédito deben ser un número positivo mayor a 0",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} min={1} />
              </Form.Item>
            </Col>
          </Row>
          )}
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Guardar Cliente
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
}

export default Createseller;
